/**
 * Cornerstone Platform SDK Client
 *
 * Initializes and exports a singleton CornerstoneClient instance
 * configured for ConnectPath's environment.
 */

import { CornerstoneClient } from '@mb/platform-sdk';
import { enhancedTokenManager } from './EnhancedTokenManager';

const CORNERSTONE_API_URL =
  (import.meta as any).env?.VITE_CORNERSTONE_API_URL || '';

const CORNERSTONE_CLIENT_ID =
  (import.meta as any).env?.VITE_CORNERSTONE_CLIENT_ID || '';

/**
 * Singleton Cornerstone client instance.
 *
 * NOTE: SessionMonitor is NOT started at construction time (HI-10 fix).
 * Token providers must be wired FIRST, then session monitoring starts.
 */
export const cornerstoneClient = new CornerstoneClient({
  baseUrl: CORNERSTONE_API_URL || 'https://cornerstone.ministry.builders/api/v1',
  serviceSlug: 'connectpath',
  // SessionMonitor deliberately NOT configured here — see below
});

// Wire token providers FIRST (before any session checks)
cornerstoneClient.setTokenProvider(() => enhancedTokenManager.getTokenSync() || '');
cornerstoneClient.setRefreshTokenProvider(() => localStorage.getItem('refresh_token') || '');
cornerstoneClient.setAuthErrorHandler(() => {
  enhancedTokenManager.clearToken();
  localStorage.removeItem('refresh_token');
  window.location.href = '/login';
});
cornerstoneClient.onTokenRefresh((tokens: { access_token: string; refresh_token?: string; expires_in?: number }) => {
  const expiresAt = new Date(Date.now() + (tokens.expires_in || 900) * 1000).toISOString();
  enhancedTokenManager.setToken(tokens.access_token, expiresAt);
  if (tokens.refresh_token) {
    localStorage.setItem('refresh_token', tokens.refresh_token);
  }
});

export { CORNERSTONE_API_URL, CORNERSTONE_CLIENT_ID };
